import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { Button } from "@faire/web--source/slate/Button";
import { Opacity } from "@faire/web--source/slate/Color";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { createPopper } from "@popperjs/core";
import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
export var DottedTooltip = function(param) {
    var text = param.text, tooltipTitle = param.tooltipTitle, tooltipText = param.tooltipText, tooltipCTA = param.tooltipCTA, tooltipCTALink = param.tooltipCTALink, _param_width = param.width, width = _param_width === void 0 ? 350 : _param_width, _param_position = param.position, position = _param_position === void 0 ? "top" : _param_position;
    var tooltipRef = useRef(null);
    var wrapperRef = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var _useState1 = _sliced_to_array(useState(), 2), popperInstance = _useState1[0], setPopperInstance = _useState1[1];
    useEffect(function() {
        if (tooltipRef.current && wrapperRef.current) {
            setPopperInstance(createPopper(wrapperRef.current, tooltipRef.current, {
                placement: position
            }));
        }
    }, [
        position
    ]);
    useEffect(function() {
        return function() {
            popperInstance === null || popperInstance === void 0 ? void 0 : popperInstance.destroy();
        };
    }, [
        popperInstance
    ]);
    var handleMouseOver = useEffectEvent(function() {
        setIsVisible(true);
        popperInstance === null || popperInstance === void 0 ? void 0 : popperInstance.setOptions({
            modifiers: [
                {
                    name: "eventListeners",
                    enabled: true
                }
            ]
        });
        popperInstance === null || popperInstance === void 0 ? void 0 : popperInstance.update();
    });
    var handleMouseOut = useEffectEvent(function() {
        setIsVisible(false);
        popperInstance === null || popperInstance === void 0 ? void 0 : popperInstance.setOptions({
            modifiers: [
                {
                    name: "eventListeners",
                    enabled: false
                }
            ]
        });
    });
    var contents = useMemo(function() {
        return [
            {
                title: tooltipTitle,
                body: tooltipText
            }
        ];
    }, [
        tooltipTitle,
        tooltipText
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                style: {
                    textDecoration: "underline",
                    textDecorationStyle: "dotted",
                    textDecorationColor: "".concat(Core.text.default + Opacity.O_50),
                    textUnderlineOffset: "3px"
                },
                variant: "paragraphSansMedium",
                ref: wrapperRef,
                children: text
            }),
            /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx("div", {
                ref: tooltipRef,
                style: {
                    display: isVisible ? "block" : "none"
                },
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    position: position,
                    width: width,
                    isOpen: true,
                    targetNode: /*#__PURE__*/ _jsx("div", {}),
                    contents: contents,
                    action: /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        tertiaryColor: Core.surface.inverse,
                        linkTo: tooltipCTALink,
                        children: tooltipCTA
                    })
                })
            }), getWindowOrThrow().document.body)
        ]
    });
};
